import checkNumberLength from "./helpers/checkNumberLength.js";
import parseDigits from "./helpers/parseDigits.js";
import formatNationalNumberUsingFormat from "./helpers/formatNationalNumberUsingFormat.js";
function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix, matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
  if (matcher.test(state.nationalSignificantNumber))
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata,
      shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix
    });
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === "IS_POSSIBLE";
}
function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  if (state.nationalSignificantNumber, state.international, state.nationalPrefix, state.carrierCode, shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix,
      metadata
    });
    if (formattedNumber)
      return formattedNumber;
  }
  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix,
    metadata
  });
}
function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix, formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata
  });
  if (useNationalPrefixFormattingRule || (state.nationalPrefix ? formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber : state.complexPrefixBeforeNationalSignificantNumber && (formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + " " + formattedNationalNumber)), isValidFormattedNationalNumber(formattedNationalNumber, state))
    return formattedNationalNumber;
}
function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}
export {
  canFormatCompleteNumber,
  formatCompleteNumber as default
};
//# sourceMappingURL=AsYouTypeFormatter.complete.js.map
